import * as _ from 'lodash';
import { RestrictionType } from './SiteSetupConstants';

export const formatRestrictionData = apiData => {
  const defaultItem = {
    ChargeByStatusMode: 2,
    MaxChargedAmtAllowed: null,
    MealCount: null,
  };

  let outputData = [];
  for (let i = 2; i < 10; i++) {
    if (i !== 5) {
      outputData.push({
        ...defaultItem,
        Status: String(i),
      });
    }
  }

  apiData = _.filter(apiData, { ChargeByStatusMode: 2 });
  if (apiData) {
    outputData.forEach(item => {
      let foundItem = _.find(apiData, { Status: item.Status });
      if (foundItem) {
        item.MealCount = String(foundItem.MealCount);
        item.NoRestrictions = false;
      } else {
        item.NoRestrictions = true;
        item.MealCount = '';
      }
    });
  }

  return outputData;
};

export const validateChargeLimits = (restrictionType, chargeLimitData) => {
  if (restrictionType === RestrictionType.Site) {
    //at least one item has a value
    let foundItem = _.find(
      chargeLimitData,
      x => x.MealCount && x.MealCount > 0
    );

    if (!foundItem) return false;
  }

  return true;
};

export const getWareHouseAndKitchenDropDownDataSource = (
  siteMasterTypeId,
  siteId,
  siteDetails
) => {
  let activeSites = _.filter(siteDetails, { IsActive: true });
  let warehouseKitchenList = _.filter(activeSites, function(item) {
    return item.SiteMasterTypeId !== siteMasterTypeId && item.Id !== siteId;
  });
  return _.map(warehouseKitchenList, function(item) {
    return {
      key: item.Id,
      value: item.Id,
      text: item.Id + ':' + item.Description,
    };
  });
};
export const getOptionsData = data => {
  return data && Array.isArray(data) && data.length > 1
    ? data.map(item => ({
        value: item.Id,
        key: item.Id,
        text: `${item.Description}`,
      }))
    : [];
};
export const containDuplicateWarehouseKitchenEntries = warehousesAndKitchens => {
  return (
    _.uniqBy(warehousesAndKitchens, 'WarehouseSiteId').length !==
    warehousesAndKitchens.length
  );
};
export const removeNullItemsFromObjectList = warehousesAndKitchens => {
  return _.filter(warehousesAndKitchens, function(item) {
    return item.WarehouseSiteId !== null;
  });
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/helpers/SiteSetupHelpers.js